/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import {
    Search,
    TOOLBAR_ITEM_TYPE,
    TOOLBAR_VIEW_TYPE,
} from '@veeam-vspc/components';

import { useLang } from 'views/providers/LangProvider/hooks';
import { StatusToggleFilter } from 'views/components/filters/StatusToggleFilter';
import { ToolbarWithExport } from 'views/components/ToolbarWithExport';
import { EJobStates } from 'core/enums';

import type { ToolbarWithExportProps } from 'views/components/ToolbarWithExport';

export interface JobObjectsFilterToolbarProps extends Omit<ToolbarWithExportProps, 'method' | 'items'> {
    method?: string;
}

export const JobObjectsFilterToolbar: React.FC<JobObjectsFilterToolbarProps> = (props) => {
    const { method, ...restProps } = props;
    const lang = useLang();
    const statuses = [
        { title: lang.SUCCESS, value: EJobStates.Success },
        { title: lang.WARNING, value: EJobStates.Warning },
        { title: lang.FAILED, value: EJobStates.Failed },
        {
            title: lang.RUNNING,
            value: [
                EJobStates.Running,
                EJobStates.Starting,
                EJobStates.Stopping,
            ],
        },
        {
            title: lang.INFORMATION,
            value: [
                EJobStates.None,
                EJobStates.Idle,
                EJobStates.Enabling,
                EJobStates.Disabling,
                EJobStates.WaitingTape,
                EJobStates.WaitingRepository,
            ],
        },
    ];

    return (
        <ToolbarWithExport
            {...restProps}
            method={method}
            view={TOOLBAR_VIEW_TYPE.spotted}
            items={[
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <Search
                            name='computerName'
                            placeholder={lang.COMPUTER}
                            hasSearchButton={true}
                            maxLength={512}
                        />
                    ),
                },
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <StatusToggleFilter
                            label={lang.JOB_STATUS}
                            statuses={statuses}
                            propName={'statuses'}
                        />
                    ),
                },
            ]}
        />
    );
};
